import { inject, Pipe, PipeTransform } from '@angular/core';
import { IAddress } from 'src/app/models/address';
import { TranslateApiPipe } from '../../translate-api/translate-api.pipe';

@Pipe({
  name: 'fullAddress'
})
export class FullAddressPipe implements PipeTransform {
  private readonly translateApi = inject(TranslateApiPipe);

  transform(value: IAddress, lang: string): string {
    if (value && Object.values(value).some(x => x)) {
      let village = value?.villages;

      let houseLabel: string = lang === 'en' ? 'House No.' : 'ផ្ទះលេខ';
      let streetLabel: string = lang === 'en' ? 'Street' : 'ផ្លូវ';
      let villageLabel: string = lang === 'en' ? 'Village' : village?.name?.slice(0, 4) !== 'ភូមិ' ? 'ភូមិ' : '';
      let communeLabel: string = lang === 'en' ? 'Commune' : 'ឃុំ/សង្កាត់';
      let districtLabel: string = lang === 'en' ? 'District' : 'ស្រុក/ខណ្ឌ';
      let provinceLabel: string = lang === 'en' ? 'Province' : 'ខេត្ត/រាជធានី';

      const house: string = value?.house ? `${houseLabel}${value.house} ` : '';
      const street: string = value?.street ? `${streetLabel}${value.street} ` : '';

      village = value?.villages ? `${villageLabel} ${this.translateApi.transform(value.villages, lang)} ` : '';

      const commune: string = value?.communes
        ? `${communeLabel} ${this.translateApi.transform(value.communes, lang)} `
        : '';

      const district: string = value?.districts
        ? `${districtLabel} ${this.translateApi.transform(value.districts, lang)} `
        : '';

      const province: string = value?.city_provinces
        ? `${provinceLabel} ${this.translateApi.transform(value.city_provinces, lang)}`
        : '';

      return `${house}${street}${village}${commune}${district}${province}`.replace(/,\s*$/, '');
    }
    return '';
  }
}
